import React, { useEffect } from "react";
import "./Home_Contact_Info.css";
import { useDispatch, useSelector } from "react-redux";
import { appSetup } from "../../../features/master/masterSlice";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faPen,
} from "@fortawesome/free-solid-svg-icons";

import {
  faWhatsapp
} from "@fortawesome/free-brands-svg-icons";

function Home_Contact_Info() {
  const dispatch = useDispatch();

  const app_setup = useSelector(
    (state) => state.master.app_setup
  );

  useEffect(() => {
    dispatch(appSetup());
  }, [dispatch]);

  const whatsappLink = app_setup?.alt_contact_no
    ? `https://wa.me/${app_setup.alt_contact_no.replace(/\D/g, "")}`
    : "#";

  return (
    <section className="home_contact_info">
      <div className="container">

        <div className="top_section">

          {/* Phone */}
          <div className="info_card">
            <div className="icon_box">
              <FontAwesomeIcon icon={faPhone} />
            </div>

            <div className="content_box">
              <h4>Call Us</h4>
              <p>Reach us for CCTV installation & support.</p>

              <a href={`tel:${app_setup?.contact_no}`}>
                {app_setup?.contact_no}
              </a>
            </div>
          </div>

          {/* Email */}
          <div className="info_card">
            <div className="icon_box">
              <FontAwesomeIcon icon={faEnvelope} />
            </div>

            <div className="content_box">
              <h4>Email Us</h4>
              <p>For sales and support enquiries.</p>

              <a href={`mailto:${app_setup?.email}`}>
                {app_setup?.email}
              </a>
            </div>
          </div>

          {/* Contact */}
          <div className="info_card">
            <div className="icon_box">
              <FontAwesomeIcon icon={faPen} />
            </div>

            <div className="content_box">
              <h4>Address</h4>

              <p>
                {app_setup?.address}
              </p>

              <a href="/contact-us">
                Contact Us
              </a>
            </div>
          </div>

          {/* WhatsApp */}
          <div className="info_card">
            <div className="icon_box">
              <FontAwesomeIcon icon={faWhatsapp} />
            </div>

            <div className="content_box">
              <h4>WhatsApp</h4>

              <p>Chat with our team directly.</p>

              <a
                href={whatsappLink}
                target="_blank"
                rel="noreferrer"
              >
                {app_setup?.alt_contact_no}
              </a>
            </div>
          </div>

        </div>

        <div className="bottom_section">

          <div className="newsletter">
            <h3>Stay Updated!</h3>
            <p>
              Subscribe to get updates on CCTV products and offers.
            </p>
          </div>

          <div className="subscribe_box">
            <input
              type="email"
              placeholder="Enter Email Address"
            />
            <button>→</button>
          </div>

         

        

        </div>

      </div>
    </section>
  );
}

export default Home_Contact_Info;